import { LocalDate } from '@fcom/core/utils/tz-date';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';

import { DirectFlightFrequency, TimetableSearchMonth } from '../interfaces/timetable-search.interface';

export const getEarliestSearchDayInMonth = ({ year, month }: TimetableSearchMonth): LocalDate => {
  const today = LocalDate.now();
  const day = LocalDate.forDate(year, month, 1);

  return LocalDate.forDate(day.toDate().getFullYear(), day.localMonth, day.lt(today) ? today.localDay : 1);
};

export const getLastDayInMonth = ({ year, month }: TimetableSearchMonth): LocalDate => {
  return LocalDate.forDateObj(new Date(year, month, 0));
};

export const getRemainingDaysInMonth = (month: TimetableSearchMonth): number => {
  const earliestDay = getEarliestSearchDayInMonth(month);
  return LocalDate.getAmountOfDaysInMonth(earliestDay.localYear, earliestDay.localMonth) - earliestDay.localDay + 1;
};

export const getDateIdsInRange = (start: LocalDate, end: LocalDate): string[] => {
  const ids: string[] = [];
  for (let day = start; day.lte(end); day = day.plusDays(1)) {
    ids.push(day.id);
  }
  return ids;
};

export const countFlightsPerDay = (
  flights: Record<string, FinnairBoundItem[]> | undefined,
  zeroFilledDateIds: string[] = []
): Record<string, number> => {
  const counts: Record<string, number> = Object.fromEntries(
    zeroFilledDateIds.map((id) => {
      return [id, 0];
    })
  );
  Object.entries(flights ?? {}).forEach(([date, bounds]) => {
    counts[date] = bounds.length;
  });
  return counts;
};

export const getDirectFlightFrequency = (
  directFlightCount: number,
  numberOfDays: number
): DirectFlightFrequency | undefined => {
  if (directFlightCount <= 0 || numberOfDays <= 0) {
    return undefined;
  }
  const averagePerDay = directFlightCount / numberOfDays;
  if (averagePerDay >= 1) {
    return { count: Math.round(averagePerDay), unit: 'day' };
  }
  return { count: Math.max(1, Math.round(averagePerDay * 7)), unit: 'week' };
};
